import { laceOfVerticalPartsRight, laceParts1, laceParts7 } from './parts/laceParts'
import { topSidePartOfWeb } from './parts/sideParts'

export const laceOfNetWebDouble = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  // 1段目
  laceOfNetWebDouble3(ctx, laceColor, 0, 0)
  // 2段目
  laceOfNetWebDouble3(ctx, laceColor, 3, 25)
  // 3段目
  laceOfNetWebDouble3(ctx, laceColor, 6, 50)
  // 4段目
  laceOfNetWebDouble3(ctx, laceColor, 9, 80)
  // 5段目
  laceOfNetWebDouble3(ctx, laceColor, 12, 110)
  // // 6段目
  // 別の場所に記述
  // ネット部分右
  // 1段目
  laceOfNetWebDouble4(ctx, laceColor, -3, -27)
  // 2段目
  laceOfNetWebDouble4(ctx, laceColor, 0, 0)
  // 3段目
  laceOfNetWebDouble4(ctx, laceColor, 7, 25)
  // 4段目
  laceOfNetWebDouble4(ctx, laceColor, 14, 48)
  // 5段目
  laceOfNetWebDouble4(ctx, laceColor, 23, 77)
  // 縦パーツ周りの革紐
  laceOfVerticalPartsRight(ctx, laceColor, -7, -27)
  laceOfVerticalPartsRight(ctx, laceColor, 0, 0)
  laceOfVerticalPartsRight(ctx, laceColor, 8, 30)
  laceOfVerticalPartsRight(ctx, laceColor, 18, 58)
  laceOfVerticalPartsRight(ctx, laceColor, 28, 85)

  // ネットウェブ用の革紐最右
  laceParts7(ctx, laceColor, -5, -35) // 上1
  laceParts7(ctx, laceColor, -3, -10) // 上2
  laceParts7(ctx, laceColor, 0, 15) // 上3
  laceParts7(ctx, laceColor, 4, 46) // 上4
  laceParts7(ctx, laceColor, 9, 75) // 上5
  // 親指側＿一番手前の革紐
  laceParts1(ctx, laceColor, 45, 75) // 上4
  laceParts1(ctx, laceColor, 32, 50) // 上3
  laceParts1(ctx, laceColor, 20, 30) // 上2
  laceParts1(ctx, laceColor, -2, -5) // 上1

  // ウェブ先端
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)

  // ウェブ下の革紐
  underLaceOfNetWeb(ctx, laceColor, -315, 140, -50) // 右端
  underLaceOfNetWeb(ctx, laceColor, -145, 102, -25) //
  underLaceOfNetWeb(ctx, laceColor, 3, 3, 0) //
  underLaceOfNetWeb(ctx, laceColor, 5, 2, 3) //
  underLaceOfNetWeb(ctx, laceColor, 5, 10, 5) //
  underLaceOfNetWeb(ctx, laceColor, 16, 9, 8) // 左端
}

const underLaceOfNetWeb = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number, numerator: number): void => {
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  ctx.lineWidth = 0.8
  ctx.beginPath()
  ctx.save()
  ctx.rotate((numerator * Math.PI) / 180)
  ctx.moveTo(333 + x, 314 + y) // 左上
  ctx.quadraticCurveTo(342 + x, 320 + y, 352 + x, 333 + y) // 左下
  ctx.quadraticCurveTo(359 + x, 330 + y, 357 + x, 325 + y) // 右下
  ctx.quadraticCurveTo(350 + x, 311 + y, 339 + x, 307 + y) // 右上
  ctx.quadraticCurveTo(328 + x, 306 + y, 333 + x, 314 + y) // 左上
  ctx.fill()
  // 上側面
  ctx.moveTo(334 + x, 312 + y) // 左上
  ctx.quadraticCurveTo(352 + x, 321 + y, 352 + x, 333 + y) // 左下
  ctx.stroke()
  ctx.restore()
  ctx.closePath()
}

const laceOfNetWebDouble4 = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number): void => {
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  ctx.lineWidth = 0.8
  ctx.beginPath()
  ctx.moveTo(303 + x, 196 + y) // 左上
  ctx.quadraticCurveTo(307 + x, 204 + y, 307 + x, 204 + y) // 左下
  ctx.quadraticCurveTo(341 + x, 158 + y, 349 + x, 156 + y) // 右下
  ctx.quadraticCurveTo(355 + x, 150 + y, 355 + x, 144 + y) // 右上
  ctx.quadraticCurveTo(338 + x, 150 + y, 303 + x, 196 + y) // 左上
  ctx.fill()
  // 上側面
  ctx.moveTo(303 + x, 200 + y) // 右上
  ctx.quadraticCurveTo(338 + x, 154 + y, 355 + x, 146 + y) // 左上
  ctx.stroke()
  ctx.closePath()
}

const laceOfNetWebDouble3 = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number): void => {
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  ctx.lineWidth = 0.8
  ctx.beginPath()
  ctx.moveTo(309 + x, 140 + y) // 左下
  ctx.quadraticCurveTo(323 + x, 147 + y, 345 + x, 150 + y) // 右下＿外
  ctx.quadraticCurveTo(367 + x, 150 + y, 361 + x, 122 + y) // 右_上＿外
  ctx.quadraticCurveTo(358 + x, 127 + y, 358 + x, 127 + y) // 右_上＿内
  ctx.quadraticCurveTo(357 + x, 143 + y, 351 + x, 143 + y) // 右下＿内
  ctx.quadraticCurveTo(332 + x, 141 + y, 317 + x, 133 + y) // 左上
  ctx.quadraticCurveTo(309 + x, 132 + y, 309 + x, 140 + y) // 左上
  ctx.fill()
  // // 上側面
  ctx.moveTo(315 + x, 135 + y) // 右上
  ctx.quadraticCurveTo(338 + x, 146 + y, 355 + x, 145 + y) // 右下
  ctx.quadraticCurveTo(363 + x, 134 + y, 360 + x, 124 + y) // 右上
  ctx.stroke()
  ctx.closePath()
}
